var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResetPassword',{attrs:{"clientType":"user","form":_vm.form,"formEmail":_vm.formEmail,"isLoading":_vm.isLoading,"passwordPolicy":_vm.passwordPolicy,"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }